import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { JwtService } from './jwtservice';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private isLoggedIn = new BehaviorSubject<boolean>(false);

  constructor(private route: Router, private jwtService: JwtService) { }

  /**
   *
   * @returns Login User Token Get
   */
  loggedIn() {
    //Check if user Token and userId exists or not. if token not available tredirect him to login
    const hasToken = !!localStorage.getItem('mbcrm/token') && !!localStorage.getItem('userId');
    if (hasToken) {
      this.isLoggedIn.next(true);
      this.jwtService.updateUserRolesFromToken();
    }
    return hasToken;
  }


  get isLoggedIn$() {
    return this.isLoggedIn.asObservable();
  }

  /**
   * Logout User
   */
  logout(): void {
    localStorage.clear();
    this.route.navigate(['/developer']);
  }
}

